export default __webpack_public_path__ + "static/part1_2mb-80947e3556954c98c2249bbd8e4dd84f.png";